import { render, staticRenderFns } from "./NavigationTopBackgroundTasks.vue?vue&type=template&id=50c60bd6&scoped=true"
import script from "./NavigationTopBackgroundTasks.vue?vue&type=script&lang=js"
export * from "./NavigationTopBackgroundTasks.vue?vue&type=script&lang=js"
import style0 from "./NavigationTopBackgroundTasks.vue?vue&type=style&index=0&id=50c60bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c60bd6",
  null
  
)

export default component.exports